<template>
  <span @click="dialog = !dialog" class="date-picker">
    <slot></slot>
  </span>
  <v-dialog v-model="dialog" max-width="min-content" persistent>
    <v-sheet>
      <v-date-picker v-model="selectedDate" :min="minDate" :max="maxDate" :color="color"></v-date-picker>
      <v-sheet class="pb-1 pr-1">
        <v-btn variant="tonal" @click="dialog = false" size="small" class="pull-right" v-if="selectedDate"
          prepend-icon="mdi-check" color="success">
          Ok
          <span class="ml-2 font-mono" v-if="countdown">({{ countdown }})</span>
        </v-btn>
        <v-btn variant="text" @click="dialog = false" size="small" text="Cancel"></v-btn>
      </v-sheet>
    </v-sheet>
  </v-dialog>
</template>

<script setup>
import { ref, computed, onBeforeUnmount, watch } from "vue";
import { useDate } from "@/Composables/useDate.js";

defineOptions({
  name: "DatePicker",
});

const props = defineProps({
  modelValue: String,
  minDate: String,
  maxDate: String,
  color: {
    type: String,
    default: "primary",
  },
  timeout: {
    type: Number,
    default: 3, // seconds
  },
  autoClose: {
    type: Boolean,
    default: true,
  },
});

const { formatDateToInput } = useDate();

const emit = defineEmits(["update:modelValue"]);

const dialog = ref(false);

const countdown = ref(null);

const interval = ref(null);

const selectedDate = computed({
  get: () => props.modelValue,
  set: (value) => {
    const formattedDate = formatDateToInput(value);

    emit("update:modelValue", formattedDate);
    if (!props.autoClose) {
      return
    }
    countdown.value = props.timeout;
    if (interval.value) {
      clearInterval(interval.value);
    }
    interval.value = setInterval(() => {
      countdown.value--;
      if (countdown.value <= 0) {
        clearInterval(interval.value);
        interval.value = null;
        dialog.value = false;
      }
    }, 1000);
    // dialog.value = false
  },
});

onBeforeUnmount(() => {
  if (interval.value) {
    clearInterval(interval.value);
  }
});

watch(countdown, (val) => {
  if (val <= 0) {
    if (interval.value) {
      clearInterval(interval.value);
    }
  }
});
</script>
